import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'src/app/modules/core/services/message.service';
import { AuthService } from '../../shared/auth.service';
import { ForgotPasswordService } from '../../shared/forgot-password.service';
import { ConfirmPasswordValidator } from '../../shared/confirm-password.validator';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.scss']
})
export class UpdatePasswordComponent implements OnInit {
  hide = true; // password hide-show
  confirmPasswordHide = true;
  form: FormGroup;
  actionCode: string;
  obbCode: string;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private forgotPasswordPopup: ForgotPasswordService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    // tslint:disable-next-line:no-string-literal
    this.obbCode = this.route['_routerState'].snapshot.root.queryParams.oobCode;
    this.form = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', Validators.required]
    }, {
      validator: ConfirmPasswordValidator.MatchPassword
    });
  }

  onSubmit(): any {
    if (this.form.status === 'VALID') {
      this.authService.resetPassword(this.obbCode, this.form.value.password).then((response) => {
        if (response.success) {
          this.forgotPasswordPopup.close();
          this.messageService.showPopup(this.translateService.instant(response.message), 'alert', 'success', 'p0Popup');
        } else {
          this.forgotPasswordPopup.close();
          this.messageService.showPopup(this.translateService.instant(response.message), 'alert', 'error', 'p0Popup');
        }
      });
    }
  }
}
